const ar = {
  welcomeMessage: 'Welcome aboard',
  home: 'Home',
  eServices: 'E-Services',
  filter: 'Filter',
  search: 'type Here To Search',
  atTime: 'At Time',
  cancel: 'Cancel',
  ok: 'Ok',
  reset: 'Reset',
  mazadat: {
    auctionAnnouncement: 'Auction Announcement',
    notRealEstateForOneHundredThousandOrLess: 'Not Real Estate For OneHundred Thousand Or Less',
    notRealEstateMoreThanOneHundredThousand: 'Not Real Estate More ThanOne Hundred Thousand',
    realEstateForOneHundredThousandOrLess: 'Real Estate For OneHundred Thousand Or Less',
    realEstateMoreThanOneHundredThousand: 'Real Estate More ThanOne Hundred Thousand',
    requestId: 'Request Id',
    mazadId: 'Mazad Id',
    hijriDate: 'Hijri Date',
    court: ' Court',
  },
  mazadInfo: {
    notRealEstateForOneHundredThousandOrLess: ' Real Estate For One Hundred Thousand Or Less',
    notRealEstateMoreThanOneHundredThousand: ' Real Estate More Than One Hundred Thousand',
    realEstateForOneHundredThousandOrLess: 'Real Estate For One Hundred Thous and OrLess',
    realEstateMoreThanOneHundredThousand: 'Real Estate More Than One Hundred Thousand',
    mazadDay: '',
    dayMeets: '',
    time: 'Time',
    location: '',
    toSell: 'to Sell',
    order: '',
    orderDate: 'Order Date',
    conclusion: 'ببيع هذا العقار كما أنه في حال رسو المزاد فإنه يسقط خيار المجلس فمن له الرغبة بدخول المزاد ممن تاهل لدخوله و أثبت ملاءته للدخول فيه التقدم لنا للتحقق التـأهل و اثبات ملائته قبل التاريخ المحدد للمزاد وفقا للمادة 49 ولوائحها من نظام التنفيذ .',
  },
  easar: {
    easarNumber: 'Easar Number',
    requestSource: 'Easar Source',
    requesterName: '',
    announce: '',
    asked: '',
    nationality: 'Nationality',
    withIdentity: '',
    claimDetails: '',
    againstName: 'Against Name',
    againstNationality: 'Nationality',
    number: 'Number',
    askForConfirm: '',
    dayMeets: '',
    time: ' Time',
    claimClosingWord: '',
    individuals: 'Individuals',
    corporates: 'Corporates',
    decisionNumber: 'Decision Number ',
    decisionDate: 'Decision Date ',
    court: 'Court',
    name: 'Easar Name',
    identityNumber: 'Identity Number',
  },
  serverErrors: {
    NOT_FOUND: 'We cannot serve you at the moment. Please try again later',
    SERVER_ERROR: 'Something went wrong, please try again later',
    USER_NOT_FOUND: 'User is not found, please try again',
  },
  months: {
    gregorian: {
      january: 'January',
      february: 'February',
      march: 'March',
      april: 'April',
      may: 'May',
      june: 'June ',
      july: 'July ',
      august: 'August',
      september: 'September',
      october: 'October',
      november: 'November',
      december: 'December',
    },
  },
  gregorian: 'ميلادي',
  hijri: 'هجري',
};

export default ar;
